import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import FAQSection from '../components/FAQ';
import Reveal from '../components/Reveal';

export default function FAQ() {
  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Answers, before you ask."
        subtitle="Common questions about assessment, doctor review, medication safety and AI-assisted support. Can't find yours? Talk to us."
      />
      <Reveal><FAQSection /></Reveal>

      <section className="bg-white">
        <div className="container-x pb-20 sm:pb-24">
          <Reveal>
            <div className="card-soft p-8 sm:p-10 grid sm:grid-cols-[auto_1fr_auto] items-center gap-5">
              <div className="w-12 h-12 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center">
                <MessageCircle size={22} />
              </div>
              <div>
                <h3 className="text-xl font-bold">Still have a question?</h3>
                <p className="text-ink-600 mt-1">Our care team replies as soon as possible — usually within one business day.</p>
              </div>
              <Link to="/contact" className="btn-primary">
                Contact us <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
